import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles, Flame } from "lucide-react";
import { Link } from "react-router-dom";

export const RisingStarsPage = () => {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/trending/rising", { params: { limit: 12 } }).then(({ data }) => setArtists(data)).catch(() => {});
  }, []);

  return (
    <div className="px-4 md:px-12 py-10 max-w-7xl mx-auto pb-32" data-testid="rising-stars-page">
      <p className="inline-flex items-center gap-2 tag-pill mb-5 bg-brand-yellow/15 border-brand-yellow/40 text-brand-yellow">
        <Flame size={12} /> Talents émergents
      </p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-4 text-balance">
        Stars <span className="bg-gradient-to-r from-brand-red via-brand-orange to-brand-yellow bg-clip-text text-transparent">montantes</span>
      </h1>
      <p className="text-white/70 text-lg mb-12 max-w-2xl">
        Les artistes qui décollent cette semaine. Découvrez-les avant qu'ils explosent.
      </p>

      {artists.length === 0 ? (
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-10 text-center">
          <p className="text-white/60">Le classement arrive dès que les premiers artistes publient.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {artists.map((a, i) => (
            <Link
              key={a.user_id}
              to={`/artist/${a.user_id}`}
              className="relative p-6 rounded-2xl border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-brand-red/30 transition-all flex items-center gap-4 overflow-hidden group"
              data-testid={`rising-artist-${a.user_id}`}
            >
              <span className="absolute top-3 right-4 font-display text-5xl font-black text-white/5 group-hover:text-brand-red/20 transition-colors">
                #{i + 1}
              </span>
              <div className="w-20 h-20 rounded-full overflow-hidden bg-gradient-to-br from-brand-red to-brand-yellow shrink-0 ring-2 ring-white/10">
                {a.picture ? (
                  <img src={a.picture} alt={a.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-white font-black text-2xl">
                    {a.name?.[0]?.toUpperCase()}
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0 relative z-10">
                <p className="font-display font-black text-xl truncate">{a.name}</p>
                <p className="text-xs text-white/60 truncate">
                  {a.country || "—"} · {a.genre || "Multi-genre"}
                </p>
                <p className="text-xs text-brand-orange mt-1">
                  {a.followers_count} followers · {a.track_count || 0} morceaux
                </p>
              </div>
              {i < 3 && (
                <Sparkles size={18} className="text-brand-yellow relative z-10" />
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default RisingStarsPage;
